import { DateTime } from 'luxon'

import { faComments } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule } from '@domain-group/suit-theme'

import useNotifications from '@hooks/useNotifications'

import Notification from '@components/Notifications/Notification/'

export const icon = faComments

export const configOptions = () => {}

interface NotificationsProps {
  editing: boolean,
}

const threeDaysAgo = DateTime.now().minus({ days: 3 }).toFormat('yyyy-MM-dd')

export const Notifications = (props: NotificationsProps) => {
  const { editing } = props

  const notificationsPayload = useNotifications({
    filters: {
      created_date_start: threeDaysAgo,
      limit: 10,
      location: 'list',
    },
    performHttpRequests: true,
    requestOptions: {
      include_notification_creator_logo: true,
      include_notification_subject: true,
    },
  })

  const {
    filteredNotifications,
    filteredNotificationsCount,
    hasFilteredNotifications,
  } = notificationsPayload

  if (!filteredNotificationsCount) return null

  return (
    <DashboardModule
      editing={editing}
      title="Notifications"
    >
      {hasFilteredNotifications && (
        <DashboardModule.ScrollableSection>
          {filteredNotifications.map(notification => (
            <Notification
              key={notification.id}
              notification={notification}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}
    </DashboardModule>
  )
}

export default Notifications
